import React from 'react';
import './IconBuddy.css';

export const IconBuddy = ({ name }) => {
  if (!name) return null

  name = name.replace(/ /g, '-').toLowerCase()

  const icons = {
    generate: generate(),
    history: history(),
    stats: stats(),
  }

  return icons[name] || null
}

const generate = () => {
  return (
    <svg className="icon icon-generate"
         width="100%"
         height="100%"
         viewBox="0 0 24 30"
         preserveAspectRatio="xMidYMid meet"
         style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: 1 }}>

      <path d="M9,5a5,5 0 1,0 0,10a5,5 0 1,0 0,-10Z" style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '2px' }} />
      <path d="M18,10a4,4 0 1,0 0,8a4,4 0 1,0 0,-8Z" style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '2px' }} />
      <path d="M1,27c0,-6.627 3.582,-12 8,-12c4.418,0 8,5.373 8,12"
        style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '2px' }} />
      <path d="M15,27c0,-5.247 2.239,-9.7 5.5,-11.3"
        style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '2px' }} />

      {/* Active-state variant — each shape is its own closed <path> (two
          circles drawn as two-arc paths, two bodies as a simple rounded-top
          silhouette) since the shared hover-fill CSS rule targets path.fill
          specifically. */}
      <path className="fill" d="M9,4a6,6 0 1,0 0,12a6,6 0 1,0 0,-12Z" style={{ fill: '#222020', stroke: 'none' }} />
      <path className="fill" d="M18,9a5,5 0 1,0 0,10a5,5 0 1,0 0,-10Z" style={{ fill: '#222020', stroke: 'none' }} />
      <path className="fill" d="M1,27L1,24Q9,12 17,24L17,27Z" style={{ fill: '#222020', stroke: 'none' }} />
      <path className="fill" d="M14,27L14,25Q18,17 22,25L22,27Z" style={{ fill: '#222020', stroke: 'none' }} />
    </svg>
  )
}

const history = () => {
  return (
    <svg className="icon icon-history"
         width="100%"
         height="100%"
         viewBox="0 0 24 30"
         preserveAspectRatio="xMidYMid meet"
         style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: 1 }}>

      <circle cx="12" cy="16" r="10" style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '2px' }} />
      <path d="M12,9v7l5,3" style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '2px' }} />
      <path d="M4,2l4,0M20,2l-4,0" style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '2px' }} />

      <circle className="fill" cx="12" cy="16" r="2" style={{ fill: '#222020', stroke: 'none' }} />
    </svg>
  )
}

const stats = () => {
  return (
    <svg className="icon icon-stats"
         width="100%"
         height="100%"
         viewBox="0 0 24 30"
         preserveAspectRatio="xMidYMid meet"
         style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: 1 }}>

      <path d="M2,28l20,0"
        style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '2px' }} />
      <path d="M5,28l0,-10M12,28l0,-18M19,28l0,-6"
        style={{ fill: 'none', stroke: 'rgb(224,218,212)', strokeWidth: '3px' }} />

      <path className="fill" d="M3,18h4v10h-4zM10,10h4v18h-4zM17,22h4v6h-4z"
        style={{ fill: '#222020', stroke: 'none' }} />
    </svg>
  )
}
